module.exports = __webpack_public_path__ + "assets/Heebo-Regular.74a4f1718b53d7bcc299cc0016882abd.woff2";